// importing Images
import contactHelp from "./images/contact_and_help.svg";
import deshiPlus from "./images/deshi_plus.svg";
import discount from "./images/discount.svg";
import newsletter from "./images/newsletter.svg";

export const FooterKnowUsBetterLinks = [
    {
        title: "About Desi Fresh",
        link: "/our-story",
    },
    {
        title: "Our Story",
        link: "/our-story",
    },
    {
        title: "Meet The Founders",
        link: "/our-story",
    },
    // {
    //   title: 'Desi Fresh Stores',
    //   link: '/',
    // },
    // {
    //   title: 'Our Suppliers',
    //   link: '/',
    // },
    // {
    //   title: 'Desi Family Card',
    //   link: '/',
    // },
    {
        title: "Desi Hands",
        link: "/desi-hands",
    },
    // {
    //   title: 'Career',
    //   link: '/',
    // },
    {
        title: "Shipping Policy",
        link: "/terms-and-condition",
    },
    // {
    //   title: 'Press',
    //   link: '/',
    // },
    // {
    //   title: 'Social Media',
    //   link: '/',
    // },
    // {
    //     title: "Sitemap",
    //     link: "/",
    // },
];

export const FooterHelpCenterLinks = [
    {
        title: "Customer Service",
        link: "/customer/customer-service",
    },
    {
        title: "Contact Us",
        link: "/contact-us",
    },
    {
        title: "Payment Methods",
        link: "/",
    },
    // {
    //   title: 'Delivery by Pickup or Shipping',
    //   link: '/',
    // },
    {
        title: "Discounts & Offers",
        link: "/category/discounts-offers-juc442_7",
    },
    // {
    //     title: "Your Account",
    //     link: "/customer/account",
    // },
    // {
    //   title: 'Coupons',
    //   link: '/',
    // },
    // {
    //   title: 'Returns & Refunds',
    //   link: '/',
    // },
    {
        title: "Product Recalls & Safety Notices",
        link: "/product-recalls",
    },
    {
        title: "FAQ’s",
        link: "/faq",
    },
    // {
    //   title: 'Checkout',
    //   link: '/',
    // },
    // {
    //   title: 'Covid-19 and Desi Fresh',
    //   link: '/',
    //   icon: '/layout-icons/covid-19.svg',
    // },
    {
        title: "Feedback",
        link: "/",
    },
];

export const FooterBusinessOpportunitiesLinks = [
    // {
    //   title: 'Sell on Desi Fresh',
    //   link: '/',
    // },
    // {
    //   title: 'Affiliate Sales Program',
    //   link: '/',
    // },
    {
        title: "Become a Supplier",
        link: "/",
    },
    {
        title: "Become an Investor",
        link: "/",
    },
    // {
    //   title: 'Accessibility',
    //   link: '/',
    // },
    // {
    //   title: 'Advertise With Us',
    //   link: '/',
    // },
    {
        title: "Become a Franchise",
        link: "/",
    },
    // {
    //   title: 'Make Money with Us',
    //   link: '/',
    // },
    // {
    //   title: 'Contribute to Blog',
    //   link: '/',
    // },
];

export const mobileAboutUs = [
    {
        title: "About Desi Fresh",
        link: "/",
    },
    {
        title: "Our Story",
        link: "/our-story",
    },
    {
        title: "Meet the Founders",
        link: "/our-story",
    },
    // {
    //   title: 'Desi Fresh Stores',
    //   link: '/',
    // },
    {
        title: "Quality & Authenticity Check",
        link: "/quality-authenticity",
    },
    // {
    //   title: 'Our Suppliers',
    //   link: '/',
    // },
    // {
    //   title: 'Desi Family Card',
    //   link: '/',
    // },
    {
        title: "Desi Hands",
        link: "/desi-hands",
    },
    // {
    //   title: 'Career',
    //   link: '/',
    // },
    {
        title: "Shipping Policy",
        link: "/terms-and-condition",
    },
    // {
    //   title: 'Press',
    //   link: '/',
    // },
    // {
    //   title: 'Social Media',
    //   link: '/',
    // },
    // {
    //     title: "Sitemap",
    //     link: "/",
    // },
];

export const mobileHelpCenter = [
    {
        title: "Customer Service",
        link: "/customer/customer-service",
    },
    {
        title: "Contact Us",
        link: "/contact-us",
    },
    {
        title: "Payment Methods",
        link: "/",
    },
    // {
    //   title: 'Delivery by Pickup or Shipping',
    //   link: '/',
    // },
    {
        title: "Discounts & Offers",
        link: "/category/discounts-offers-juc442_7",
    },
    // {
    //   title: 'Coupons',
    //   link: '/',
    // },
    // {
    //   title: 'Returns & Refunds',
    //   link: '/',
    // },
    // {
    //   title: 'Product Recall',
    //   link: '/',
    // },
    {
        title: `FAQ's`,
        link: "/faq",
    },
    // {
    //   title: `Checkout`,
    //   link: '/',
    // },
    // {
    //   title: `Covid 19 and Desi Fresh`,
    //   link: '/',
    // },
    {
        title: `Feedback`,
        link: "/",
    },
];

export const mobileDeshiBusiness = [
    {
        title: "Sell on Desi Fresh",
        link: "/",
    },
    {
        title: "Affliate Program",
        link: "/",
    },
    {
        title: "Our Suppliers",
        link: "/",
    },
    {
        title: "Accessibilty",
        link: "/",
    },
    {
        title: "Advertise with us",
        link: "/",
    },
];

export const mobileExtraLinks = [
    {
        title: "Contact & Help",
        link: "/",
        icon: contactHelp,
    },
    {
        title: "Disounts & Offers ",
        link: "/category/discounts-offers-juc442_7",
        icon: discount,
    },
    {
        title: "Desi Plus",
        link: "/",
        icon: deshiPlus,
    },
    {
        title: "Newsletter",
        link: "/",
        icon: newsletter,
    },
];

export const businessOpportunities = [
    {
        title: "Sell on Desi Fresh",
        link: "/",
    },
    {
        title: "Affiliate Sales Program",
        link: "/",
    },
    {
        title: "Become a Supplier",
        link: "/",
    },
    {
        title: "Become an Investor",
        link: "/",
    },
    {
        title: "Accesibility",
        link: "/",
    },
    {
        title: "Advertise With Us",
        link: "/",
    },
    {
        title: "Become a Franchise",
        link: "/",
    },
    {
        title: "Contribute to Blog",
        link: "/",
    },
];

export const reaction_data = [
    {
        id: 1,
        rating: 1,
        icon: "/icon/faces/1.png",
        text: "We are sorry that you are not able to find your searched product. Please text below your product interest for future.",
    },
    {
        id: 2,
        rating: 2,
        icon: "/icon/faces/2.png",
        text: "We are sorry that you are not able to find your searched product. Please text below your product interest for future.",
    },
    {
        id: 3,
        rating: 3,
        icon: "/icon/faces/5.png",
        text: "Glad to know you found your searched item. What would you suggest us to make our search or service better.",
    },
    {
        id: 4,
        rating: 4,
        icon: "/icon/faces/4.png",
        text: "Glad to know you found your searched item. What would you suggest us to make our search or service better.",
    },
    {
        id: 5,
        rating: 5,
        icon: "/icon/faces/3.png",
        text: "Glad to know you found your searched item. What would you suggest us to make our search or service better.",
    },
];
